<div class="cos-drawer-inner-container" cdkScrollable #content>
  <ng-content />
</div>
